export const LESSON_MAX_BLOCK_COUNT = 10;
export const BLOCK_FOR = {
  lesson: "lesson",
  premiumArticle: "premiumArticle",
}
